/**
 * Single shared API client instance for apps/admin.
 *
 * Wires `@sparta/api-client` with the env-derived base URL and a
 * Sentry-backed drift reporter. Critical-endpoint registrations (per
 * CLAUDE.md rule §16) are performed by feature modules at module-load
 * time — Phase 1 features import this file's `apiClient` for actual
 * requests AND register their endpoints during slice initialisation.
 */

import * as Sentry from '@sentry/react';
import { createApiClient, type DriftReporter } from '@sparta/api-client';
import { env } from './env.js';

const driftReporter: DriftReporter = (report) => {
  // Sentry SDK is a no-op if not initialised — safe to call regardless.
  Sentry.captureException(
    new Error(
      `Critical-endpoint drift: ${report.endpoint.method} ${report.endpoint.path} response failed schema parse`,
    ),
    {
      tags: {
        endpoint_path: report.endpoint.path,
        endpoint_method: report.endpoint.method,
      },
      extra: {
        zodIssues: report.parseError.issues,
      },
    },
  );
};

export const apiClient = createApiClient({
  baseUrl: env.apiBaseUrl,
  onDrift: driftReporter,
});
